const getters = {
  token: state => state.token,
  avatar: state => state.currentAdmin ? state.currentAdmin.photo : '',
  developer : state => state.currentAdmin ? state.currentAdmin.developer : '',
  userName: state => state.currentAdmin ? state.currentAdmin.userName : '',
  developerChecked: state => state.developerChecked,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js